'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'UserRestService',
    function ($modal, UserRestService) {

        return {
            select: select,
            edit: edit,
            create: create,
            api: UserRestService
        };

        function select(user, filters) {
            // return $modal.open({
            //     template: require('../view/user-modal-select.html'),
            //     controller: 'UserModalSelectController',
            //     size: 'lg',
            //     backdrop: false,
            //     resolve: {
            //         user: function () {
            //             return user != null ? user : {};
            //         },
            //         userFilters: function () {
            //             return filters != null ? filters : [];
            //         }
            //     }
            // });
        }

        function create(def) {
            return $modal.open({
                template: require('../view/user-modal-create.html'),
                controller: 'UserModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    user: function () {
                        return {
                            accountNonLocked: true
                        };
                    }
                }
            });
        }

        function edit(item) {
            return $modal.open({
                template: require('../view/user-modal-create.html'),
                controller: 'UserModalCreateController',
                size: 'md',
                backdrop: false,
                resolve: {
                    user: function () {
                        return item;
                    }
                }
            });
        }

    }];